import digitalData from 'digital-data';
import {
  BUTTON_SUBMISSION, CONTENT, MODULE_CLICK, NOT_APPLICABLE, SLM_WIDGET_ID
} from '../../../constants';
import { setAnalytics } from '../../../thd-analytics-utils';

export function pathToProNetwork() {
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('pathToProNetwork.landing.page-load', () => {
    digitalData.page = {
      pageInfo: {
        pageName: 'skilled labor marketplace',
        pageType: CONTENT,
      },
      category: {
        primaryCategory: 'skilled labor marketplace',
        subCategory1: 'skilled labor marketplace',
        subCategory2: 'skilled labor marketplace',
      },
    };

    setAnalytics(digitalData);
  });

  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('pathToProNetwork.landing.click-find-candidate', () => {
    (digitalData?.event || []).push({
      category: { primaryCategory: 'button submission' },
      eventInfo: { eventName: 'content module click' },
      pageType: CONTENT,
      content: {
        widgets: [
          {
            action: 'find candidates',
            id: SLM_WIDGET_ID,
            name: NOT_APPLICABLE,
            templates: 'skilled labor candidates',
            campaign: 'subcontent_slm',
            component: 'etch',
          },
        ],
      }
    });

    setAnalytics(digitalData);
  });

  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('pathToProNetwork.candidates-search.page-load', () => {
    digitalData.page = {
      pageInfo: {
        pageName: 'skilled labor marketplace>profile search',
        pageType: CONTENT,
      },
      category: {
        primaryCategory: 'skilled labor marketplace',
        subCategory1: 'skilled labor marketplace>profile search',
        subCategory2: 'skilled labor marketplace>profile search',
      },
    };

    setAnalytics(digitalData);
  });

  LIFE_CYCLE_EVENT_BUS.lifeCycle.on(
    'pathToProNetwork.candidates-search.filter-interaction',
    ({ output: { templates = '' } }) => {
      (digitalData?.event || []).push({
        category: { primaryCategory: BUTTON_SUBMISSION },
        eventInfo: { eventName: MODULE_CLICK },
        pageType: CONTENT,
        content: {
          widgets: [
            {
              action: 'search/filter',
              id: SLM_WIDGET_ID,
              name: NOT_APPLICABLE,
              templates,
              campaign: 'subcontent_slm',
              component: 'etch',
            },
          ],
        },
      });

      setAnalytics(digitalData);
    }
  );

  LIFE_CYCLE_EVENT_BUS.lifeCycle.on(
    'pathToProNetwork.candidates-search.candidate-overlay-view',
    ({ output: { candidateId } }) => {
      (digitalData?.event || []).push({
        category: {
          primaryCategory: 'overlay',
        },
        eventInfo: {
          eventName: 'slm candidate profile modal',
        },
        content: {
          slmCandidateID: candidateId,
        },
      });

      setAnalytics(digitalData);
    }
  );

  LIFE_CYCLE_EVENT_BUS.lifeCycle.on(
    'pathToProNetwork.candidates-search.contact-candidate',
    ({ output: { candidateId, templates } }) => {
      (digitalData?.event || []).push({
        category: { primaryCategory: BUTTON_SUBMISSION },
        eventInfo: { eventName: MODULE_CLICK },
        pageType: CONTENT,
        content: {
          slmCandidateID: candidateId,
          widgets: [
            {
              action: 'contact',
              id: SLM_WIDGET_ID,
              name: NOT_APPLICABLE,
              templates,
              campaign: 'subcontent_slm',
              component: 'etch',
            },
          ],
        },
      });

      setAnalytics(digitalData);
    }
  );

  LIFE_CYCLE_EVENT_BUS.lifeCycle.on(
    'pathToProNetwork.candidates-search.social-link-click',
    ({ output: { candidateId, socialNetwork } }) => {
      (digitalData?.event || []).push({
        category: { primaryCategory: BUTTON_SUBMISSION },
        eventInfo: { eventName: MODULE_CLICK },
        pageType: CONTENT,
        content: {
          slmCandidateID: candidateId,
          widgets: [
            {
              action: 'click',
              id: SLM_WIDGET_ID,
              name: NOT_APPLICABLE,
              templates: `profile>${socialNetwork}`,
              campaign: 'subcontent_slm',
              component: 'etch',
            },
          ],
        },
      });

      setAnalytics(digitalData);
    }
  );

  LIFE_CYCLE_EVENT_BUS.lifeCycle.on(
    'pathToProNetwork.candidates-search.hire-this-candidate',
    ({ output: { hiredBool, location, candidateId } }) => {
      (digitalData?.event || []).push({
        category: { primaryCategory: BUTTON_SUBMISSION },
        eventInfo: { eventName: MODULE_CLICK },
        pageType: CONTENT,
        content: {
          slmCandidateID: candidateId,
          widgets: [
            {
              action: 'click',
              id: SLM_WIDGET_ID,
              name: NOT_APPLICABLE,
              templates: hiredBool ? `hired>${location}` : `not hired>${location}`,
              campaign: 'subcontent_slm',
              component: 'etch',
            },
          ],
        },
      });

      setAnalytics(digitalData);
    }
  );
}
